import React from "react";
import "./reviews.scss";

// swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Pagination } from "swiper/modules";

// data
import { reviewsData } from "../../../assets/data/reviewsData";

// components
import Wrapper from "../../layouts/wrapper/Wrapper";
import CommonHeader from "../../common/commonHeader/CommonHeader";

const Reviews = () => {
  return (
    <section id="reviews">
      <Wrapper>
        <section className="reviews">
          <CommonHeader
            title="Feedback"
            subtitle="Our Client’s Feedback"
            bgText="Client’s Feedback"
            center={true}
          />

          <div className="review_container">
            <Swiper
              spaceBetween={30}
              autoplay={{
                delay: 3500,
                disableOnInteraction: false,
              }}
              loop={true}
              speed={2500}
              pagination={{
                clickable: true,
                dynamicBullets: true,
              }}
              modules={[Autoplay, Pagination]}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                  spaceBetween: 30,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1150: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
              }}
              className="review_swiper"
            >
              {reviewsData.map((item, index) => (
                <SwiperSlide key={index} className="review_swiperSlide">
                  <div className="review_container__card__img">
                    <img src={item.img} alt="" />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>
      </Wrapper>
    </section>
  );
};

export default Reviews;
